import { useState, useEffect } from 'react';
import AddReminderButton from './lead-journey/addNewReminderButton';
import { useGetReminder } from '../api/reminder/useGetReminder';
import ResponsiveModal from './ui/ResponsiveModal';
import { useIsMobile } from '@/hooks';

export default function ReminderComponent({leadID, owner}) {
  const isMobile = useIsMobile();
  const [showTable, setShowTable] = useState(false); // Controls whether the table is shown
  const {lastReminder, allReminders, refetch} = useGetReminder({leadID})

  const handleReminderAdd = () =>{
    refetch();
  };
  // Close the modal
  const closeModal = () => {
    setShowTable(false);
  };

  return (  

    <div className="p-3 md:p-5 flex flex-col bg-white shadow-sm rounded-2xl md:rounded-3xl w-full md:w-1/2 md:ml-8">
      <div className="flex justify-between items-center md:items-start w-full border-b border-gray-300 pb-2 mb-3">
        <div className='flex items-center'>
          <img src="/icons/notifications_active.svg" className='size-5 md:size-7 flex-shrink-0'/>
          <h1 className="ml-2 font-semibold text-lg md:text-3xl">Reminders</h1>
        </div>
        {owner && <AddReminderButton leadID={leadID} onReminderAdd = {handleReminderAdd}/>}
      </div>
      

      <div className="flex flex-col">
      {/* Display Last Reminder */}
      {lastReminder?.reminder_at ? (
        <div className="mb-3 md:mb-4 w-full">
          <div className='flex justify-between items-start mb-2'>
            <h2 className="text-sm md:text-lg font-normal text-gray-400">Upcoming Reminder:</h2>
            {/* View All Button */}
            <button
              onClick={() => setShowTable(true)}
              className="text-black underline hover:text-blue-800 focus:outline-none font-bold text-xs md:text-sm flex-shrink-0 min-h-[44px] flex items-center"
            >
              View All
            </button>
          </div>
          <div className='bg-yellow-100 rounded-2xl md:rounded-3xl px-3 md:px-4 py-2 md:py-3 border-[1px] border-yellow-300 w-full'>
            <p className="text-gray-700 font-light text-xs md:text-sm"> {lastReminder.reminder_at}</p>
            <p className="text-gray-700 text-base md:text-lg mt-1"><b>{lastReminder.reminder_title}</b></p>
            <p className="text-gray-700 text-sm md:text-base mt-1">{lastReminder.reminder_details}</p>
          </div>
        </div>
      ) : (
        <p className="text-gray-500 text-sm md:text-base">No reminders available.</p>
      )}
      
      </div>

      

      {/* Modal to display the table of all reminders */}
      <ResponsiveModal
        isOpen={showTable}
        onClose={closeModal}
        title="All Reminders"
        size="lg"
      >
        {isMobile ? (
          /* Mobile: Card View */
          <div className="space-y-3">
            {allReminders && allReminders.length > 0 ? (
              allReminders.map((reminder) => (
                <div key={reminder.id} className="bg-white border border-gray-200 rounded-lg p-4 shadow-sm">
                  <h3 className="font-bold text-base mb-2">{reminder.reminder_title}</h3>
                  <p className="text-sm text-gray-600 mb-2">{reminder.reminder_at}</p>
                  <p className="text-sm text-gray-900">{reminder.reminder_details}</p>
                </div>
              ))
            ) : (
              <div className="text-center py-8 text-gray-500">
                No reminders found
              </div>
            )}
          </div>
        ) : (
          /* Desktop: Table View */
          <div className="overflow-x-auto">
            <table className="min-w-full bg-white border border-gray-200">
              <thead>
                <tr className="bg-gray-100 border-none text-neutral-400">
                  <th className="py-2 px-4 text-start text-lg">Title</th>
                  <th className="py-2 px-4 text-start text-lg">Date</th>
                  <th className="py-2 px-4 text-start text-lg">Details</th>
                </tr>
              </thead>
              <tbody>
                {allReminders && allReminders.length > 0 ? (
                  allReminders.map((reminder) => (
                    <tr key={reminder.id} className="border-gray-200 border">
                      <td className="py-2 px-4"><b>{reminder.reminder_title}</b></td>
                      <td className="py-2 px-4"><b>{reminder.reminder_at}</b></td>
                      <td className="py-2 px-4"><b>{reminder.reminder_details}</b></td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan={3} className="py-4 px-4 text-center text-gray-500">
                      No reminders found
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        )}
      </ResponsiveModal>
    </div>
  );
}